import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import interviewDropdownAPI from "../../services/interviewApi";
import { setMessage } from "./Messages";

export const getScheduledInterview = createAsyncThunk(
  "interviewDetails/getScheduledInterview",
  async (thunkAPI) => {
    try {
      const data = await interviewDropdownAPI.getScheduledInterviewApi();
      return { response: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getInterviewTimeSlots = createAsyncThunk(
  "interviewDetails/getInterviewTimeSlots",
  async (props, thunkAPI) => {
    try {
      const data = await interviewDropdownAPI.getInterviewTimeSlotsApi(props);
      return { response: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const confirmScheduledInterview = createAsyncThunk(
  "interviewDetails/confirmScheduledInterview",
  async (props, thunkAPI) => {
    try {
      const data = await interviewDropdownAPI.confirmScheduledInterviewApi(
        props
      );
      return { response: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getInterviewDetails = createAsyncThunk(
  "interviewDetails/getInterviewDetails",
  async (props, thunkAPI) => {
    try {
      const data = await interviewDropdownAPI.getInterviewDetailsApi(props);
      return { response: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const rescheduleInterview = createAsyncThunk(
  "interviewDetails/rescheduleInterview",
  async (props, thunkAPI) => {
    try {
      const data = await interviewDropdownAPI.rescheduleInterviewApi(props);
      return { response: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const cancelInterviewSchedule = createAsyncThunk(
  "interviewDetails/cancelInterviewSchedule",
  async (props, thunkAPI) => {
    try {
      const data = await interviewDropdownAPI.cancelInterviewApi(props);
      return { response: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const declineInterviewSchedule = createAsyncThunk(
  "interviewDetails/declineInterviewSchedule",
  async (props, thunkAPI) => {
    try {
      const data = await interviewDropdownAPI.declineInterviewScheduleApi(
        props
      );
      return { response: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  interviewList: [],
  timeSlots: null,
  interviewData: null,
};

const interviewDropdownLists = createSlice({
  name: "interviewDetails",
  initialState,
  extraReducers: {
    [getScheduledInterview.fulfilled]: (state, action) => {
      state.interviewList = action.payload.response.data;
    },
    [getScheduledInterview.rejected]: (state) => {
      state.interviewList = [];
    },
    [getInterviewTimeSlots.fulfilled]: (state, action) => {
      state.timeSlots = action.payload.response.data;
    },
    [getInterviewTimeSlots.rejected]: (state) => {
      state.timeSlots = [];
    },
    [getInterviewDetails.fulfilled]: (state, action) => {
      state.interviewData = action.payload.response.data;
    },
    [getInterviewDetails.rejected]: (state) => {
      state.interviewData = [];
    },
  },
});

const { reducer } = interviewDropdownLists;
export default reducer;
